import { useState, type FormEvent } from "react";

import { useController, useGame } from "../context";

export function ConnectScreen() {
  const controller = useController();
  const busy = useGame((s) => s.busy);
  const [code, setCode] = useState("");

  const submit = (event: FormEvent) => {
    event.preventDefault();
    void controller.joinFromInput(code);
  };

  return (
    <section className="screen screen--centered">
      <h3 className="section-title">Подключиться к комнате</h3>
      <form onSubmit={submit}>
        <input
          className="room-input"
          type="text"
          maxLength={200}
          autoComplete="off"
          autoCapitalize="characters"
          spellCheck={false}
          placeholder="Введите код комнаты"
          aria-label="Код комнаты"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <div>
          <button type="submit" className="btn" disabled={busy || code.trim() === ""}>
            Подключиться
          </button>
        </div>
      </form>
      {controller.canScanQr && (
        <>
          <button type="button" className="btn" onClick={() => void controller.scanQr()}>
            Сканировать QR
          </button>
          <p className="hint">Сканируйте QR код комнаты</p>
        </>
      )}
      <button type="button" className="btn" onClick={() => controller.goHome()}>
        Отмена
      </button>
    </section>
  );
}
